import { AxiosInstance } from "axios";
import {
  baseApi,
  formApi,
  orderApi,
  notificationApi,
  integrationApi,
  contentManagerApi,
  malgaVirtualApi,
} from "./axiosInstances";

const apis: AxiosInstance[] = [
  baseApi,
  formApi,
  orderApi,
  notificationApi,
  integrationApi,
  contentManagerApi,
  malgaVirtualApi,
];

export const updateHeaders = (headers: Record<string, string>): void => {
  apis.forEach((api) => {
    Object.keys(headers).forEach((key) => {
      api.defaults.headers.common[key] = headers[key];
    });
  });
};

export const updateSingleHeader = (
  api: AxiosInstance,
  headers: Record<string, string>
): void => {
  Object.keys(headers).forEach((key) => {
    api.defaults.headers.common[key] = headers[key];
  });
};
